import { IconStyled, IconStylesProps } from './IconStyles';

export const LockOpened = ({
  size = 'base',
  className = '',
  fill = 'currentColor',
}: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    className={className}
    viewBox='0 0 12 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M6.1848 0C7.54928 0 8.71203 0.883992 8.97544 2.10184C9.02669 2.33879 8.86015 2.56922 8.60345 2.61653C8.34676 2.66384 8.09712 2.51011 8.04587 2.27316C7.87079 1.46368 7.09647 0.875 6.1848 0.875C5.18428 0.875 4.3646 1.58965 4.29215 2.49612L4.28694 2.62687L4.28693 4.375H9.97917C11.0262 4.375 11.875 5.1585 11.875 6.125V12.25C11.875 13.2165 11.0262 14 9.97917 14H2.39583C1.34879 14 0.5 13.2165 0.5 12.25V6.125C0.5 5.1585 1.34879 4.375 2.39583 4.375H3.33901L3.33903 2.62687C3.33903 1.17609 4.61312 0 6.1848 0ZM9.97917 5.25H2.39583C1.87231 5.25 1.44792 5.64175 1.44792 6.125V12.25C1.44792 12.7332 1.87231 13.125 2.39583 13.125H9.97917C10.5027 13.125 10.9271 12.7332 10.9271 12.25V6.125C10.9271 5.64175 10.5027 5.25 9.97917 5.25ZM6.1875 8.3125C6.71102 8.3125 7.13542 8.70425 7.13542 9.1875C7.13542 9.67075 6.71102 10.0625 6.1875 10.0625C5.66398 10.0625 5.23958 9.67075 5.23958 9.1875C5.23958 8.70425 5.66398 8.3125 6.1875 8.3125Z'
      fill={fill}
    />
  </IconStyled>
);
